/**
 * Escapes a value for safe embedding inside a JavaScript string literal.
 * Handles backslashes that would otherwise create escape sequences
 * and break the string (e.g., a company name containing "\").
 *
 * This is needed because Handlebars' escapeExpression() only escapes
 * HTML entities (& < > " ' ` =), not JS-significant characters like \.
 */
export default function escapeForJsString(value: { toString(): string } | string | boolean | undefined | null): string {
  if (value == null) return '';
  const str = typeof value === 'string' ? value : value.toString();
  return str.replace(/\\/g, '\\\\').replace(/\n/g, '\\n').replace(/\r/g, '\\r');
}
